/* eslint-disable indent */
import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Row, Col, Alert } from 'react-bootstrap'
import axios from 'axios'

const TrainingStandardsModal = ({
  show,
  onHide,
  currentStandards,
  currentName,
  onSaveStandards,
  onTypeSeasonSaved,
  candidate,
  id,
}) => {
  // Vakioasetukset
  const defaultStandards = {
    coach: { target: 5, tolerance: 0 },
    assistants: { target: 10, tolerance: 0 },
    intensity: { target: 100, tolerance: 0 },
    stamina: { target: 5, tolerance: 0 },
    minutes: { target: 90, tolerance: 0 },
    efficiency: { target: 1, tolerance: 0 },
    medic: { target: 5, tolerance: 0 },
    formCoach: { target: 0, tolerance: 0 },
  }

  const [standards, setStandards] = useState(
    currentStandards || defaultStandards
  )
  const [listName, setListName] = useState(currentName || '')
  const [teamType, setTeamType] = useState(
    candidate ? candidate.TeamType : 'MJ'
  )
  const [season, setSeason] = useState(candidate ? candidate.Season : null)
  const [competition, setCompetition] = useState(
    candidate && candidate.TeamType === 'U21'
      ? candidate.Competition || 'CC'
      : 'CC'
  )
  const [isSaving, setIsSaving] = useState(false)
  const [message, setMessage] = useState({ type: '', text: '' })

  useEffect(() => {
    if (currentStandards) {
      setStandards(currentStandards)
    } else {
      setStandards(defaultStandards)
    }
    setListName(currentName || '')
    setTeamType(candidate ? candidate.TeamType : 'MJ')
    setSeason(candidate ? candidate.Season : null)
    setCompetition(
      candidate && candidate.TeamType === 'U21'
        ? candidate.Competition || 'CC'
        : 'CC'
    )
  }, [currentStandards, currentName, candidate, show])

  const handleChange = (field, subField, value) => {
    setStandards(prev => ({
      ...prev,
      [field]: {
        ...prev[field],
        [subField]: Number(value),
      },
    }))
  }

  const handleSave = async () => {
    setIsSaving(true)
    setMessage({ type: '', text: '' })

    try {
      // Tallenna harjoitusvaatimukset ja nimi
      await onSaveStandards(standards, listName)

      // Tallenna listan tyyppi ja kausi
      if (candidate && id) {
        const loggedUser = window.localStorage.getItem('loggedUser')
        const token = loggedUser ? JSON.parse(loggedUser) : null

        const typeSeasonResponse = await axios.put(
          `/api/candidates/${id}/type-season`,
          {
            TeamType: teamType,
            Season: teamType === 'U21' ? season : null,
            Competition: teamType === 'U21' ? competition || 'CC' : undefined,
          },
          {
            headers: {
              'x-oauth-token': token,
            },
          }
        )

        if (onTypeSeasonSaved && typeSeasonResponse?.data) {
          await onTypeSeasonSaved(typeSeasonResponse.data)
        }
      }

      setMessage({ type: 'success', text: 'Asetukset tallennettu!' })
      setTimeout(() => {
        onHide()
        setMessage({ type: '', text: '' })
      }, 1000)
    } catch (error) {
      setMessage({
        type: 'danger',
        text: 'Tallentaminen epäonnistui: ' + error.message,
      })
    } finally {
      setIsSaving(false)
    }
  }

  const handleResetDefaults = () => {
    setStandards(defaultStandards)
  }

  const standardFields = [
    {
      key: 'coach',
      label: 'Valmentaja',
      targetMin: 1,
      targetMax: 8,
      toleranceMax: 3,
    },
    {
      key: 'assistants',
      label: 'Apuvalmentajat',
      targetMin: 0,
      targetMax: 10,
      toleranceMax: 5,
    },
    {
      key: 'intensity',
      label: 'Intensiteetti (%)',
      targetMin: 0,
      targetMax: 100,
      toleranceMax: 20,
    },
    {
      key: 'stamina',
      label: 'Kestävyysharjoittelu (%)',
      targetMin: 0,
      targetMax: 100,
      toleranceMax: 10,
    },
    {
      key: 'minutes',
      label: 'Peliminuutit',
      targetMin: 0,
      targetMax: 90,
      toleranceMax: 20,
    },
    {
      key: 'efficiency',
      label: 'Harjoitusteho',
      targetMin: 0,
      targetMax: 1,
      toleranceMax: 0.5,
      step: 0.1,
    },
    {
      key: 'medic',
      label: 'Lääkäri',
      targetMin: 0,
      targetMax: 10,
      toleranceMax: 3,
    },
    {
      key: 'formCoach',
      label: 'Kuntovalkku',
      targetMin: 0,
      targetMax: 10,
      toleranceMax: 3,
    },
  ]

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header
        closeButton
        style={{ backgroundColor: '#23272A', color: '#FFFFFF' }}
      >
        <Modal.Title>Listan asetukset</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: '#2C2F33', color: '#FFFFFF' }}>
        {/* Listan nimi */}
        <Form.Group className="mb-4">
          <Form.Label>Listan nimi</Form.Label>
          <Form.Control
            type="text"
            value={listName}
            onChange={e => setListName(e.target.value)}
            placeholder="Anna listalle nimi"
            style={{
              backgroundColor: '#1E2124',
              color: '#FFFFFF',
              borderColor: '#444',
            }}
          />
        </Form.Group>

        {/* Listan tyyppi ja kausi */}
        <Row className="mb-4">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Listan tyyppi</Form.Label>
              <Form.Select
                value={teamType}
                onChange={e => setTeamType(e.target.value)}
                style={{
                  backgroundColor: '#1E2124',
                  color: '#FFFFFF',
                  borderColor: '#444',
                }}
              >
                <option value="MJ">Miesten joukkue (MJ)</option>
                <option value="U21">U21-joukkue</option>
              </Form.Select>
            </Form.Group>
          </Col>
          {teamType === 'U21' && (
            <Col md={6}>
              <Form.Group>
                <Form.Label>Kausi</Form.Label>
                <Form.Control
                  type="number"
                  value={season || ''}
                  onChange={e =>
                    setSeason(e.target.value ? Number(e.target.value) : null)
                  }
                  placeholder="Syötä kauden numero"
                  style={{
                    backgroundColor: '#1E2124',
                    color: '#FFFFFF',
                    borderColor: '#444',
                  }}
                />
              </Form.Group>
            </Col>
          )}
        </Row>

        {teamType === 'U21' && (
          <Row className="mb-4">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Kilpailu</Form.Label>
                <div
                  style={{
                    backgroundColor: '#1E2124',
                    borderRadius: '5px',
                    overflow: 'hidden',
                    width: 'fit-content',
                  }}
                >
                  <Button
                    variant={
                      (competition || 'CC') === 'CC'
                        ? 'info'
                        : 'outline-secondary'
                    }
                    size="sm"
                    onClick={() => setCompetition('CC')}
                    style={{
                      borderRadius: 0,
                      border: 'none',
                      padding: '5px 20px',
                    }}
                  >
                    CC (MMK)
                  </Button>
                  <Button
                    variant={
                      (competition || 'CC') === 'WC'
                        ? 'info'
                        : 'outline-secondary'
                    }
                    size="sm"
                    onClick={() => setCompetition('WC')}
                    style={{
                      borderRadius: 0,
                      border: 'none',
                      padding: '5px 20px',
                    }}
                  >
                    WC (MM)
                  </Button>
                </div>
              </Form.Group>
            </Col>
          </Row>
        )}

        <hr style={{ borderColor: '#444' }} />

        <h6>Harjoitusvaatimukset</h6>
        <p style={{ color: '#888', marginBottom: '20px', fontSize: '0.85rem' }}>
          Määritä harjoitusasetuksille tavoitearvot ja toleranssit. Pelaajan
          asetus näytetään vihreänä, jos se on tavoitteen ± toleranssin sisällä.
        </p>

        {message.text && <Alert variant={message.type}>{message.text}</Alert>}

        {standardFields.map(field => (
          <Row key={field.key} className="mb-3 align-items-center">
            <Col xs={12} md={4}>
              <Form.Label style={{ marginBottom: 0 }}>{field.label}</Form.Label>
            </Col>
            <Col xs={6} md={4}>
              <Form.Group>
                <Form.Label
                  style={{ fontSize: '0.8rem', color: '#888', marginBottom: 0 }}
                >
                  Tavoite
                </Form.Label>
                <Form.Control
                  type="number"
                  min={field.targetMin}
                  max={field.targetMax}
                  step={field.step || 1}
                  value={standards[field.key] ? standards[field.key].target : 0}
                  onChange={e =>
                    handleChange(field.key, 'target', e.target.value)
                  }
                  style={{
                    backgroundColor: '#1E2124',
                    color: '#FFFFFF',
                    borderColor: '#444',
                  }}
                />
              </Form.Group>
            </Col>
            <Col xs={6} md={4}>
              <Form.Group>
                <Form.Label
                  style={{ fontSize: '0.8rem', color: '#888', marginBottom: 0 }}
                >
                  Toleranssi (±)
                </Form.Label>
                <Form.Control
                  type="number"
                  min={0}
                  max={field.toleranceMax}
                  value={
                    standards[field.key] ? standards[field.key].tolerance : 0
                  }
                  onChange={e =>
                    handleChange(field.key, 'tolerance', e.target.value)
                  }
                  style={{
                    backgroundColor: '#1E2124',
                    color: '#FFFFFF',
                    borderColor: '#444',
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
        ))}

        <hr style={{ borderColor: '#444' }} />

        <div className="mt-3">
          <h6>Esikatselu:</h6>
          <div
            style={{
              backgroundColor: '#1E2124',
              padding: '15px',
              borderRadius: '5px',
            }}
          >
            {standardFields.map(field => (
              <div key={field.key} style={{ marginBottom: '5px' }}>
                <strong>{field.label}:</strong>{' '}
                {standards[field.key] ? standards[field.key].target : 0}
                {standards[field.key] &&
                  standards[field.key].tolerance > 0 &&
                  ` (±${standards[field.key].tolerance})`}
                <span style={{ color: '#888', marginLeft: '10px' }}>
                  → Hyväksytty alue:{' '}
                  {(standards[field.key] ? standards[field.key].target : 0) -
                    (standards[field.key] ? standards[field.key].tolerance : 0)}
                  -
                  {(standards[field.key] ? standards[field.key].target : 0) +
                    (standards[field.key] ? standards[field.key].tolerance : 0)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ backgroundColor: '#23272A' }}>
        <Button variant="outline-secondary" onClick={handleResetDefaults}>
          Palauta vakiot
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Peruuta
        </Button>
        <Button variant="info" onClick={handleSave} disabled={isSaving}>
          {isSaving ? 'Tallennetaan...' : 'Tallenna'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default TrainingStandardsModal
